import { OrderFilter } from '@/types/orders.type';

export const getDataWithEmptyDaysAndCorrectLabel = (
  data: { label: string; sales: number }[],
  filter: OrderFilter,
) => {
  switch (filter) {
    case OrderFilter.TODAY:
      return getDataForToday(data);

    case OrderFilter.THIS_WEEK:
      return getDataForLast7Days(data);

    case OrderFilter.THIS_MONTH:
      return getDataForThisMonth(data);
    case OrderFilter.THIS_YEAR:
      return getDataForThisYear(data);
    default:
      return data;
  }
};

const getDataForToday = (data: { label: string; sales: number }[]) => {
  const salesWithConvertedLabels = data.map((item) => ({
    ...item,
    label: new Date(item.label).toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
    }),
  }));
  return salesWithConvertedLabels;
};

const getDataForLast7Days = (data: { label: string; sales: number }[]) => {
  const last7Days = generateLast7Days();
  return last7Days.map((day) => {
    const matchingSales = data.find((sale) => sale.label === day.label);
    return matchingSales
      ? { ...matchingSales, label: matchingSales.label.slice(5, 10) }
      : { ...day, label: day.label.slice(5, 10) };
  });
};

const getDataForThisMonth = (data: { label: string; sales: number }[]) => {
  const daysInMonth = generateDaysInMonth();
  return daysInMonth.map((day) => {
    const matchingSales = data.find((sale) => sale.label === day.label);
    return matchingSales
      ? { ...matchingSales, label: matchingSales.label.slice(5, 10) }
      : { ...day, label: day.label.slice(5, 10) };
  });
};

const generateLast7Days = () => {
  const today = new Date();
  const last7Days = [];

  for (let i = 6; i >= 0; i--) {
    const date = new Date(today);
    date.setDate(today.getDate() - i);
    last7Days.push({
      label: date.toISOString().split('T')[0],
      sales: 0,
    });
  }

  return last7Days;
};

const generateDaysInMonth = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth();
  const day = today.getDate();

  const allDays = [];

  for (let i = 1; i <= day; i++) {
    const date = new Date(year, month, i);
    allDays.push({
      label: date.toISOString().split('T')[0], // Format as YYYY-MM-DD
      sales: 0,
    });
  }

  return allDays;
};

const getDataForThisYear = (data: { label: string; sales: number }[]) => {
  const monthsInYear = generatePastMonthsInYear();
  return monthsInYear.map((month) => {
    const matchingSales = data.find((sale) => sale.label === month.label);
    return matchingSales ? matchingSales : month;
  });
};

const generatePastMonthsInYear = () => {
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth(); // 0 = January, 11 = December

  const pastMonths = [];

  for (let month = 0; month <= currentMonth; month++) {
    const date = new Date(currentYear, month, 1);
    const monthLabel = date.toISOString().slice(0, 7); // Extract YYYY-MM

    pastMonths.push({
      label: monthLabel,
      sales: 0,
    });
  }

  return pastMonths;
};
